import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=c84cf4b2&"
import script from "./userMenu.vue?vue&type=script&lang=js&"
export * from "./userMenu.vue?vue&type=script&lang=js&"
import style0 from "./userMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports